import { z } from 'zod';

export const QUERY_TYPES = [
  'RawSql',
  'RawSqlUnsafe',
  'PrismaQuery',
  'JsFunction',
  'StaticList',
] as const;

export const CONNECTIONS = ['AstroDB', 'FlowDB', 'FlowDBReader', 'Redshift'] as const;

export const templateFiltersSchema = z.object({
  name: z.string().min(1).optional().catch(undefined),
  queryType: z.array(z.enum(QUERY_TYPES)).optional().catch(undefined),
  connection: z.array(z.enum(CONNECTIONS)).optional().catch(undefined),
  /** 'published' or 'draft'. A single choice, so it is not an array. */
  published: z.enum(['published', 'draft']).optional().catch(undefined),
});

export type TemplateFilterValues = z.infer<typeof templateFiltersSchema>;
